"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
exports.registerSchemaMethod = registerSchemaMethod;
exports.fixSchemaOptions = fixSchemaOptions;
exports.mergeOptions = mergeOptions;
const schemaMethods = __importStar(require("../schemaMethods"));
const validationMessages_1 = require("../validationMessages");
/**
 * domyslne opcje schematu
 */
exports.defaultOptions = {
    resetOnFocus: true,
    dirtyOnInput: false,
    dirtyOnBlur: true,
    startDirtyOnCalc: true,
    disableCalculations: false,
    disableValidations: false,
    startDirty: false,
    lazyNumbers: false,
    schemaMethods,
    // wrapAll: false,
    fixData: true,
    fixFormat: false,
    fixTypes: false,
    logErrors: process.env.NODE_ENV !== 'production',
    logWarnings: process.env.NODE_ENV !== 'production',
    validationMessages: validationMessages_1.validationMessages,
    warningMessages: validationMessages_1.validationMessages,
    form: {},
    external: {},
    readOnly: false,
    longGuids: false,
    forceCalcEnabled: false
};
/**
 * rejestrownie metody globalnej dla schema
 * @param name nazwa metody
 * @param fn funkcja
 */
function registerSchemaMethod(name, fn) {
    exports.defaultOptions.schemaMethods[name] = fn;
}
/**
 * łączenie opcji z opcjami domyslnymi
 *
 * @export
 * @param {*} [options]
 * @returns {IOptions}
 */
function fixSchemaOptions(options) {
    const result = {};
    mergeOptions(result, exports.defaultOptions);
    if (options) {
        mergeOptions(result, options);
    }
    return result;
}
/**
 * dołaczanie opcji *
 * @export
 * @param {IOptions} options
 * @param {IOptions} optionsToMerge
 * @param {number} level poziom opcji
 */
function mergeOptions(options, optionsToMerge, level = 0) {
    for (const key in optionsToMerge) {
        // eslint-disable-next-line no-prototype-builtins
        if (optionsToMerge.hasOwnProperty(key)) {
            const value = optionsToMerge[key];
            if (value !== undefined) {
                if (level === 0) {
                    //wszystkie internal
                    if (key[0] === '_')
                        continue;
                    switch (key) {
                        case 'external':
                        case 'prevModel':
                        case 'form':
                        case 'i18n':
                        case 'Vue':
                            options[key] = value;
                            continue;
                        case 'schemaMethods':
                            if (options.schemaMethods) {
                                options.schemaMethods = Object.assign({}, options.schemaMethods, optionsToMerge.schemaMethods);
                            }
                            else {
                                options.schemaMethods = optionsToMerge.schemaMethods;
                            }
                            continue;
                        case '_disabledFields':
                        case '_readedErrorFields':
                        case '_anyEvent':
                        case '_forceRecalc':
                            continue;
                    }
                }
                if (typeof value === 'object' && value != null && !Array.isArray(value)) {
                    if (options[key] === undefined) {
                        options[key] = {};
                    }
                    mergeOptions(options[key], value, level + 1);
                }
                else {
                    options[key] = value;
                }
            }
        }
    }
}
//# sourceMappingURL=IOptions.js.map